export const getCountry = state => state.countrySelection.country;
